export default [
  {
    path:'/admin/store_member/overview',
    name:'StoreMemberOverview',
    component:()=>import('@/views/store_member/overview'),
    meta:{
      title:'多商户-总览'
    }
  },
  {
    path:'/admin/store_member/goods_list',
    name:'StoreGoodsList',
    component:()=>import('@/views/store_member/goodslist'),
    meta:{
      title:'多商户-商品列表'
    }
  },
  {
    path:'/admin/store_member/goods/edit',
    name:'StoreGoodsEdit',
    component:()=>import('@/views/store_member/goodsedit'),
    meta:{
      title:'多商户-商品列表'
    }
  },
  {
    path:'/admin/store_member/goods_server',
    name:'StoreGoodsService',
    component:()=>import('@/views/store_member/goodsservice'),
    meta:{
      title:'多商户-商品服务'
    }
  },
  {
    path:'/admin/store_member/frieght/list',
    name:'StoreFrieghtList',
    component:()=>import('@/views/store_member/frieghtlist'),
    meta:{
      title:'多商户-运费规则'
    }
  },
  {
    path:'/admin/store_member/frieght/edit',
    name:'StoreFrieghtEdit',
    component:()=>import('@/views/store_member/frieghtedit'),
    meta:{
      title:'多商户-新增-编辑运费规则'
    }
  },
  {
    path:'/admin/store_member/coupon',
    name:'StoreCoupon',
    component:()=>import('@/views/store_member/coupon'),
    meta:{
      title:'多商户-优惠券'
    }
  },
  {
    path:'/admin/store_member/withdraw',
    name:'StoreWithdraw',
    component:()=>import('@/views/store_member/withdraw'),
    meta:{
      title:'多商户-提现'
    }
  },
  {
    path:'/admin/store_member/total_money',
    name:'StoreTotalMoney',
    component:()=>import('@/views/store_member/totalmoney'),
    meta:{
      title:'多商户-资金总览'
    }
  },
  {
    path:'/admin/store_member/bill_log',
    name:'StoreBillLog',
    component:()=>import('@/views/store_member/billlog'),
    meta:{
      title:'多商户-账单明细'
    }
  },
  {
    path:'/admin/store_member/pay_log',
    name:'StorePayLog',
    component:()=>import('@/views/store_member/paylog'),
    meta:{
      title:'多商户-账单明细'
    }
  },
  {
    path:'/admin/store_member/order_list',
    name:'StoreOrderList',
    component:()=>import('@/views/store_member/orderlist'),
    meta:{
      title:'多商户-订单列表'
    }
  },
  {
    path:'/admin/store_member/sales_order',
    name:'StoreSalesOrder',
    component:()=>import('@/views/store_member/salesorder'),
    meta:{
      title:'多商户-售后订单'
    }
  },
  {
    path:'/admin/store_member/storeinfo',
    name:'StoreInfo',
    component:()=>import('@/views/store_member/storeinfo'),
    meta:{
      title:'多商户-基本信息'
    }
  },
  {
    path:'/admin/store_member/order_dtl',
    name:'StoreOrderDtl',
    component:()=>import('@/views/store_member/orderdetails'),
    meta:{
      title:'多商户-订单详情'
    }
  },
  {
    path:'/admin/store_member/coupon_edit',
    name:'StoreCouponEdit',
    component:()=>import('@/views/store_member/couponedit'),
    meta:{
      title:'多商户-优惠券'
    }
  },
  {
    path:'/admin/store_member/user_list',
    name:'StoreUserList',
    component:()=>import('@/views/store_member/user/userlist'),
    meta:{
      title:'多商户-会员列表'
    }
  },
  {
    path:'/admin/store_member/user_dtl',
    name:'StoreUserDtl',
    component:()=>import('@/views/store_member/user/userdtl'),
    meta:{
      title:'多商户-会员档案'
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/store_member.js